export interface RenamePhotoModalProps {
  value: string
  originalLabel: string
  loading: boolean
  onValueChange: (value: string) => void
  onSubmit: () => void
  onClose: () => void
}

export default function RenamePhotoModal({
  value,
  originalLabel,
  loading,
  onValueChange,
  onSubmit,
  onClose,
}: RenamePhotoModalProps) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content rename-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Rename Photo</h3>
        <div className="rename-input-wrapper">
          <input
            type="text"
            value={value}
            onChange={(e) => onValueChange(e.target.value)}
            placeholder="Enter new name"
            autoFocus
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !loading) onSubmit()
              if (e.key === 'Escape' && !loading) onClose()
            }}
          />
          {/*
            Known, deliberately preserved inconsistency: this display check
            (`.includes('.')`) disagrees with the edit-value split above
            (`lastIndexOf('.') > 0`) for a leading-dot name like `.gitignore`
            — the span renders `.gitignore` and so does the input, so the
            user sees the name twice. Submission is unaffected. This is a
            recorded product finding, not something to fix inside a refactor.
          */}
          <span className="rename-extension">
            {originalLabel.includes('.') ? originalLabel.substring(originalLabel.lastIndexOf('.')) : ''}
          </span>
        </div>
        <div className="modal-actions">
          <button
            onClick={onSubmit}
            className="primary-button"
            disabled={loading || !value.trim()}
          >
            {loading ? 'Renaming...' : 'Rename'}
          </button>
          <button onClick={onClose} disabled={loading}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
